import type { CSSProperties } from 'react'

import WeCheckGlyph from '@/assets/sidebar/weCheckGlyph.svg?react'
import { useAppSelector } from '@/hooks/redux'
import { selectIsDarkMode } from '@/store/api/Ui/Ui.selector'

import type { ProdDevAssetsTypes } from './WecheckEnvironmentDistinction.types'

export const WecheckEnvironmentDistinction = ({
  environment,
}: ProdDevAssetsTypes) => {
  const isDarkMode = useAppSelector(selectIsDarkMode)
  const isDev = environment !== 'production'

  const glyphStyle = {
    '--fill-0': isDarkMode ? '#fafafa' : '#1C2226',
  } as CSSProperties

  return (
    <div className="flex items-center gap-2">
      <div className="h-6 w-6" style={glyphStyle}>
        <WeCheckGlyph />
      </div>
      <p className="text-sm font-medium tracking-tight text-neutralColor">
        WeCheck AI{isDev && <span className="text-dynamicGreen"> DEV</span>}
      </p>
    </div>
  )
}
